import { trackingPlanEnum } from "../dictionary/global-country-dictionary";
import LocalStorageService from "../services/local-storage.service";
const localStorageService = LocalStorageService.getService();

export const trademoTrackingEvents = function (eventType, data) {
  if (process.env.NODE_ENV.toLowerCase() === "production") {
    window.pendo.track(eventType, data);
  }
};

export const generateTrackingObject = function () {
  let planData = localStorageService.getPlanDetails();
  let dataSource = localStorageService.getUserData() ? localStorageService.getUserData().current_product : "";
  let returnObject = {
    dataSource: dataSource,
    urlData: window.location.pathname,
    plan: mapCurrentPlanOfUser(planData),
  };
  // End of the above object
  return returnObject;
};

const mapCurrentPlanOfUser = function (str) {
  if (str.includes(trackingPlanEnum.free.key) === true) {
    return trackingPlanEnum.free.value;
  } else if (str.includes(trackingPlanEnum.basic.key) === true) {
    return trackingPlanEnum.basic.value;
  } else if (str.includes(trackingPlanEnum.essential.key) === true) {
    return trackingPlanEnum.essential.value;
  } else if (str.includes(trackingPlanEnum.plus.key) === true) {
    return trackingPlanEnum.plus.value;
  } else if (str.includes(trackingPlanEnum.starter.key) === true) {
    return trackingPlanEnum.starter.value;
  } else if (str.includes(trackingPlanEnum.advanced.key) === true) {
    return trackingPlanEnum.advanced.value;
  } else if (str.includes(trackingPlanEnum.enterprise.key) === true) {
    return trackingPlanEnum.enterprise.value;
  } else if (str.includes(trackingPlanEnum.proLite.key) === true) {
    return trackingPlanEnum.proLite.value;
  } else if (str.includes(trackingPlanEnum.pro2.key) === true) {
    return trackingPlanEnum.pro2.value;
  } else if (str.includes(trackingPlanEnum.pro.key) === true) {
    return trackingPlanEnum.pro.value;
  } else {
    return trackingPlanEnum.unknown.value;
  }
};
